var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0 {\n\t\t\tfill: #414141\n\t\t}\n\n\t\t.prefix__st1 {\n\t\t\tfill-rule: evenodd;\n\t\t\tclip-rule: evenodd;\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-linecap: round;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M23 4v16H1V4h22m1-1H0v18h24V3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M4.2 11.3C6.5 9.8 9.1 9 12 9c2.9 0 5.5.9 7.8 2.4M7.7 12.8h8.6M9.8 15.4h4.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M3.6 5.9c.4 0 .7.3.7.7s-.4.6-.7.6-.7-.3-.7-.6.3-.7.7-.7m0-1c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.8-1.7-1.7-1.7zM3.6 16.8c.4 0 .7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7m0-1c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.8-1.7-1.7-1.7zM20.4 5.9c.4 0 .7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.4-.7.7-.7m0-1c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.7-1.7-1.7-1.7zM20.4 16.8c.4 0 .7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.4-.7.7-.7m0-1c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.7-1.7-1.7-1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurities);
export default __webpack_public_path__ + "static/media/securities.bab127dd745b1e64cf558f3a1e322e76.svg";
export { ForwardRef as ReactComponent };